// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ClearOutlinedSvg from "@ant-design/icons-svg/es/asn/ClearOutlined";
import AntdIcon from '../components/AntdIcon';

var ClearOutlined = function ClearOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ClearOutlinedSvg
  }));
};

ClearOutlined.displayName = 'ClearOutlined';
export default React.forwardRef(ClearOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ClearOutlined.js
// module id = 775
// module chunks = 0